<div class="option-section">
  <span class="title-sub-section">{{ title }}</span>

  <hr class="mt-1 mb-0">

  <ng-content></ng-content>
</div>
